import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';

@Component({
  selector: 'app-vistoria-cautelar',
  templateUrl: './vistoria-cautelar.component.html',
  styleUrls: ['./vistoria-cautelar.component.scss']
})
export class VistoriaCautelarComponent implements OnInit, AfterViewInit {

  @ViewChild("institucionalVideo", { static: false })
  institucionalVideo?: ElementRef<HTMLVideoElement>;

  private observer?: IntersectionObserver;

  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  ngOnInit() {

  }
  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const video = this.institucionalVideo?.nativeElement;
    if (!video) return;

    this.observer = new IntersectionObserver(
      async (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          await this.tryPlay(video);
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    this.observer.observe(video);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = undefined;
  }

  private async tryPlay(video: HTMLVideoElement): Promise<void> {
    try {
      await video.play();
    } catch {
      try {
        video.muted = true;
        await video.play();
      } catch {}
    }
  }
}
